import React, { useEffect, useState } from "react";

export default function PrivacyPolicy() {
  // Initialize dark mode state from localStorage
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    const theme = localStorage.getItem("theme");
    if (theme) {
      return theme === "dark";
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  // Update when theme changes in localStorage
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'theme') {
        setIsDarkMode(e.newValue === 'dark');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Also check for the dark class on the HTML element
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const hasDarkClass = document.documentElement.classList.contains('dark');
      setIsDarkMode(hasDarkClass);
    });

    observer.observe(document.documentElement, { attributes: true });
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`min-h-screen w-full mt-4 ${isDarkMode ? 'bg-gray-900' : 'bg-gray-100'}`}>
      <div className="max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8 pt-24">
        <div className={`shadow rounded-lg p-6 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
          <h1 className={`text-3xl font-bold mb-8 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
            Privacy Policy
          </h1>

          <section className="space-y-6">
            <div className="space-y-4">
              <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                16912249 Canada Inc. dba Swiftclear Technologies (further referred to as
                Swiftclear) has created this privacy statement to demonstrate its
                firm commitment to privacy. Swiftclear takes your privacy seriously.
                Our goal in collecting personal information is to provide you with
                the best and most useful content and services.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className={`text-2xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Personal Information
              </h2>
              <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                If you should provide Swiftclear with your email address or other
                personal information as part of a subscription or email newsletter
                sign-up, we will never provide that email address directly to
                third-party advertisers unless it is clearly mentioned at the time
                of sign-up or unless you directly provide us with permission to do
                so.
              </p>
              <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                We will deliver email newsletters until you request to unsubscribe
                or the newsletters are discontinued by us. You will always have the
                opportunity to unsubscribe and opt-out of future emails at your
                discretion. Any information submitted to Swiftclear is kept
                completely confidential and will not be shared or sold.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className={`text-2xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Registration and Order Forms
              </h2>
              <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Our site's registration forms may require users to give us contact
                information (such as their name, e-mail, and postal address).
                Contact information from the registration forms is used to provide
                information about our company, and to send promotional material to
                our customers and site users who request information sent to them.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className={`text-2xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                External Links
              </h2>
              <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                This site contains links to other sites. Swiftclear is not
                responsible for the privacy practices or the content of such
                websites. Other websites may post their own privacy policies to
                inform visitors of their current practices.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className={`text-2xl font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                Contact Us
              </h2>
              <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                If you have any questions about this privacy statement, the
                practices of this site, or your dealings with this website, please
                contact us.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
